<template>
  <div class="flex items-start gap-x-[11px] rounded-xl bg-[#ebedef]/50 p-2.5">
    <div v-for="side in sides" :key="side.label" class="contents">
      <SortIcon
        v-if="side.glyph"
        class="size-[18px] shrink-0 rotate-90 text-gray-400"
        :class="actions ? 'mt-10' : 'mt-4'"
        aria-hidden="true"
      />
      <div class="min-w-0 flex-1">
        <div class="text-[12px] leading-4 text-gray-500">{{ side.label }}</div>
        <div class="mt-1 flex items-center gap-x-2.5">
          <div class="size-[30px] shrink-0">
            <Thumbnail
              :type="fileTypeToThumbnail(side.work.type ?? FileType.Generic)"
              :src="side.work.src"
            />
          </div>
          <div
            v-truncate
            class="min-w-0 flex-1 text-[14px] leading-[18px] text-gray-800"
          >
            <div data-truncate-target>{{ side.work.name }}</div>
          </div>
        </div>
        <Button
          v-if="actions"
          variant="stroke"
          :size="isMobile ? 'lg' : 'md'"
          class="mt-2 w-full"
          :disabled="!side.onClick"
          @click="side.onClick?.()"
        >
          {{ side.action }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Button, Thumbnail } from '@dacr/library'
import { SortIcon } from '@dacr/icons'

import { useDevice } from '@/shared/composables/useDevice'
import { FileType } from '@/shared/graphql/router/graphql'
import { fileTypeToThumbnail } from '@/shared/utils/thumbnail'

export interface MatchSide {
  name: string
  type: FileType | null | undefined
  src?: string
}

const props = defineProps<{
  registered: MatchSide
  infringing: MatchSide
  actions?: { onView?: () => void; onDetails: () => void }
}>()

const { isMobile } = useDevice()

const sides = computed(() => [
  {
    label: 'Your registered work',
    work: props.registered,
    action: 'View',
    onClick: props.actions?.onView,
    glyph: false,
  },
  {
    label: 'Potential infringing work',
    work: props.infringing,
    action: 'Details',
    onClick: props.actions?.onDetails,
    glyph: true,
  },
])
</script>
